import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import { EditUserRequest, User } from './types';

export const editMe = async (
  data: EditUserRequest
): Promise<User | undefined> => {
  const response = await apiRequest<Response<User>, EditUserRequest>(
    endpoints.user.editMe,
    RequestMethodEnum.PATCH,
    { data }
  );
  return response?.data;
};

export const editUser = async (
  id: number,
  data: EditUserRequest
): Promise<User | undefined> => {
  const response = await apiRequest<Response<User>, EditUserRequest>(
    endpoints.user.update(id),
    RequestMethodEnum.PATCH,
    { data }
  );
  return response?.data;
};

export const getMe = async (): Promise<User> => {
  const response = await apiRequest<Response<User>, void>(
    endpoints.user.getMe,
    RequestMethodEnum.GET,
    {}
  );

  if (!response?.data) {
    throw new Error('User not authenticated');
  }

  return response.data;
};

export const getUser = async (id: number): Promise<User | undefined> => {
  const response = await apiRequest<Response<User>, void>(
    endpoints.user.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const getUsers = async (): Promise<User[]> => {
  const response = await apiRequest<Response<User[]>, void>(
    endpoints.user.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const deleteUser = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.user.delete(id),
    RequestMethodEnum.DELETE,
    {}
  );
  return response?.data;
};

export const deleteMe = async (): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.user.deleteMe,
    RequestMethodEnum.DELETE,
    {}
  );
  return response?.data;
};
